"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOSSwitch = exports.Switch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var context_1 = require("../../context");
function Switch(_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, variant = _a.variant, _d = _a.style, style = _d === void 0 ? {} : _d;
    var switchVariant = (0, context_1.useTwapContext)().uiPreferences.switchVariant;
    var props = {
        style: { pointerEvents: disabled ? "none" : "unset" },
        className: "twap-switch ".concat(className),
        checked: value,
        onChange: function (event) { return onChange(event.target.checked); },
    };
    var _variant = variant || switchVariant;
    if (_variant === "ios") {
        return (0, jsx_runtime_1.jsx)(IOSSwitch, __assign({}, props, { style: style, disabled: disabled }));
    }
    return (0, jsx_runtime_1.jsx)(material_1.Switch, __assign({}, props, { style: style, disabled: disabled }));
}
exports.Switch = Switch;
var IOSSwitch = (0, material_1.styled)(function (props) { return (0, jsx_runtime_1.jsx)(material_1.Switch, __assign({ focusVisibleClassName: ".Mui-focusVisible", disableRipple: true }, props)); })(function (_a) {
    var theme = _a.theme;
    return ({
        width: 50,
        height: 26,
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 3,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(24px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
                    opacity: 1,
                    border: 0,
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5,
                },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d",
                border: "6px solid #fff",
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
            },
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 20,
            height: 20,
        },
        "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
                duration: 500,
            }),
        },
    });
});
exports.IOSSwitch = IOSSwitch;
